import { cn } from '@/lib/utils';

const LoadingSpinnerSmall = ({ className = 'h-9 w-9' }) => (
  <div className="loading-spinner-small">
    <div
      className={cn(
        'animate-spin rounded-full border-t-2 border-b-2 border-colors-green',
        className
      )}
    ></div>
  </div>
);

export default LoadingSpinnerSmall;
